import Header from './header';
import Footer from "./footer";

import React from "react";

const Layout = (props) => {
  return (
      <div className="main-content" style={{backgroundColor: '#fafafd'}}>
        <Header is_mobile={props.is_mobile}/>
        <div>{props.children} </div>
        <div style={{marginBottom: '2em'}}></div>
        <Footer offer_loading={props.offer_loading} is_mobile={props.is_mobile}/>
      </div>
  );
};

export default Layout;